module.exports = __webpack_public_path__ + "img/Ambiente.221f21e4.svg";